import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const purchases = [{
  name: 'Carlos M.',
  city: 'Houston, TX'
}, {
  name: 'Miguel R.',
  city: 'Los Angeles, CA'
}, {
  name: 'José L.',
  city: 'Miami, FL'
}, {
  name: 'David P.',
  city: 'Chicago, IL'
}, {
  name: 'Andrés G.',
  city: 'Dallas, TX'
}, {
  name: 'Luis F.',
  city: 'New York, NY'
}, {
  name: 'Roberto S.',
  city: 'Phoenix, AZ'
}, {
  name: 'Fernando T.',
  city: 'Atlanta, GA'
}, {
  name: 'Diego H.',
  city: 'Denver, CO'
}, {
  name: 'Alejandro V.',
  city: 'San Antonio, TX'
}, {
  name: 'Marcos C.',
  city: 'Charlotte, NC'
}, {
  name: 'Raúl N.',
  city: 'Las Vegas, NV'
}];
function getRandomPurchase() {
  const index = Math.floor(Math.random() * purchases.length);
  const minutesAgo = Math.floor(Math.random() * 15) + 1;
  return {
    ...purchases[index],
    minutesAgo
  };
}
export function PurchaseBanner() {
  const [visible, setVisible] = useState(false);
  const [purchase, setPurchase] = useState(getRandomPurchase);
  useEffect(() => {
    const interval = setInterval(() => {
      setPurchase(getRandomPurchase());
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    }, 40000);
    // Show first one after 8 seconds
    const initialTimeout = setTimeout(() => {
      setPurchase(getRandomPurchase());
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    }, 8000);
    return () => {
      clearInterval(interval);
      clearTimeout(initialTimeout);
    };
  }, []);
  return <AnimatePresence data-id="element-1">
      {visible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 200
    }} className="fixed left-3 bottom-20 md:bottom-6 z-50 max-w-[280px]" data-id="element-2">
          <div className="bg-dark-card border border-gold/30 rounded-lg p-3 shadow-xl shadow-black/50 flex items-center gap-3" data-id="element-3">
            <div className="w-9 h-9 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0" data-id="element-4">
              <ShoppingBag className="w-4 h-4 text-gold" data-id="element-5" />
            </div>
            <div className="min-w-0" data-id="element-6">
              <p className="font-inter text-white text-sm font-semibold truncate" data-id="element-7">
                {purchase.name} · {purchase.city}
              </p>
              <p className="font-inter text-gray-400 text-xs" data-id="element-8">
                Compró: El Método Acento Prohibido
              </p>
              <p className="font-inter text-gold text-xs mt-0.5" data-id="element-9">
                $6.39 · hace {purchase.minutesAgo} min
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}